const CEP_HEADER_STORAGE_KEY = "ws_customer_location";

function formatarCepHeader(valor) {
  const digitos = (valor || "").replace(/\D/g, "").slice(0, 8);
  if (digitos.length > 5) return digitos.slice(0, 5) + "-" + digitos.slice(5);
  return digitos;
}

function lerLocalizacaoCepHeader() {
  try {
    const raw = localStorage.getItem(CEP_HEADER_STORAGE_KEY);
    if (raw) return JSON.parse(raw);
    return null;
  } catch (e) {
    return null;
  }
}

async function buscarViaCep(cep) {
  const resp = await fetch("https://viacep.com.br/ws/" + cep + "/json/");
  if (!resp.ok) throw new Error("ViaCEP indisponível");
  const data = await resp.json();
  if (data.erro) throw new Error("CEP não encontrado");
  return data;
}

// Espelha o CEP informado aqui no topo pra chave que o carrinho e o checkout
// usam no cálculo de frete: CEP_CART_KEEP (mesma de wsapi3-checkout-cart.js,
// wsapi3-cart-sidebar.js, wsapi3-cart-drawer-rules.js e wsapi3-pag-prod-rules.js).
// Assim o campo de CEP do frete já vem preenchido nesses fluxos quando o cliente
// preenche por aqui. Gravado como 8 dígitos limpos — formato que esses módulos
// esperam (eles fazem .replace(/\D/g,"") na leitura e sempre gravam "clean").
function sincronizarCepCartKeep() {
  try {
    const loc = lerLocalizacaoCepHeader();
    const cep = ((loc && loc.zipcode) || "").replace(/\D/g, "");
    if (cep.length === 8) localStorage.setItem("CEP_CART_KEEP", cep);
  } catch (e) {}
}

function salvarLocalizacaoCepHeader(payload) {
  const completo = {
    source: "manual-cep",
    zipcode: payload.cep || "",
    state: payload.uf || "",
    address: payload.logradouro || "",
    number: "",
    complement: payload.complemento || "",
    neighborhood: payload.bairro || "",
    city: payload.localidade || "",
    lat: null,
    lon: null,
    updated_at: new Date().toISOString(),
  };
  localStorage.setItem(CEP_HEADER_STORAGE_KEY, JSON.stringify(completo));
  sincronizarCepCartKeep();
  window.wsCustomerLocation = completo;
  window.dispatchEvent(
    new CustomEvent("wsCustomerLocationUpdated", { detail: completo }),
  );
}

function atualizarBotaoCepHeader() {
  const ufEl = document.querySelector(".cep-header-uf");
  const cepEl = document.querySelector(".cep-header-cep");
  const loc = lerLocalizacaoCepHeader();
  const temCep = !!(loc && loc.zipcode);

  if (ufEl) ufEl.textContent = (loc && loc.state) || "Informe seu cep";
  if (cepEl) {
    cepEl.textContent = temCep ? formatarCepHeader(loc.zipcode) : "";
    cepEl.style.display = temCep ? "" : "none";
  }
}

function preencherInputCepHeader() {
  const input = document.querySelector(".cep-header-input");
  if (!input || input.value) return;
  const loc = lerLocalizacaoCepHeader();
  if (loc && loc.zipcode) input.value = formatarCepHeader(loc.zipcode);
}

async function confirmarCepHeader() {
  const input = document.querySelector(".cep-header-input");
  const erro = document.querySelector(".cep-header-erro");
  const btnOk = document.querySelector(".cep-header-ok");
  if (!input || !erro || !btnOk) return;
  if (btnOk.disabled) return;

  erro.hidden = true;
  const cepLimpo = (input.value || "").replace(/\D/g, "");
  if (cepLimpo.length !== 8) {
    erro.textContent = "Digite um CEP com 8 dígitos.";
    erro.hidden = false;
    return;
  }

  btnOk.disabled = true;
  input.disabled = true;

  try {
    const data = await buscarViaCep(cepLimpo);
    salvarLocalizacaoCepHeader(data);
    atualizarBotaoCepHeader();
    const container = document.querySelector("[data-cep-header]");
    if (container) {
      container.classList.add("fechando");
      setTimeout(() => {
        container.classList.remove("aberto");
        container.classList.remove("fechando");
        container.classList.add("confirmado");
        window.location.reload();
      }, 600);
    } else {
      window.location.reload();
    }
    input.blur();
  } catch (e) {
    erro.textContent = "CEP inválido. Tente novamente.";
    erro.hidden = false;
  } finally {
    btnOk.disabled = false;
    input.disabled = false;
  }
}

// Único disparo de navigator.geolocation.getCurrentPosition() do tema — sempre atrás de um
// clique explícito aqui (window.wsRequestPreciseGeolocation, exposta por body.html). Sem isso
// o navegador nunca pede permissão de localização sozinho no carregamento da página.
function usarLocalizacaoAtualCepHeader() {
  const btn = document.querySelector(".cep-header-usar-local");
  const erro = document.querySelector(".cep-header-erro");
  if (!btn || typeof window.wsRequestPreciseGeolocation !== "function") return;

  btn.disabled = true;
  if (erro) erro.hidden = true;

  window.wsRequestPreciseGeolocation((sucesso) => {
    btn.disabled = false;
    if (!sucesso && erro) {
      erro.textContent = "Não foi possível obter sua localização. Informe o CEP manualmente.";
      erro.hidden = false;
    }
    // wsCustomerLocationUpdated (disparado por salvarLocalizacao em body.html) já aciona
    // atualizarBotaoCepHeader()/preencherInputCepHeader() sozinho quando dá certo.
  });
}

function inicializarCepHeader() {
  const btnOk = document.querySelector(".cep-header-ok");
  const input = document.querySelector(".cep-header-input");
  const btnLocal = document.querySelector(".cep-header-usar-local");
  if (!btnOk || !input) return;

  btnOk.addEventListener("click", confirmarCepHeader);
  if (btnLocal) btnLocal.addEventListener("click", usarLocalizacaoAtualCepHeader);

  input.addEventListener("input", (e) => {
    e.target.value = formatarCepHeader(e.target.value);
  });

  input.addEventListener("keydown", (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      confirmarCepHeader();
    }
  });

  atualizarBotaoCepHeader();
  preencherInputCepHeader();
  // Backfill: se o cliente já tinha informado o CEP no topo antes desse
  // espelhamento existir, alimenta o CEP_CART_KEEP no primeiro carregamento.
  sincronizarCepCartKeep();
}

try {
  isReady("categorias", inicializarCepHeader);
} catch (error) {}

window.addEventListener("wsCustomerLocationUpdated", () => {
  atualizarBotaoCepHeader();
  preencherInputCepHeader();
  // Cobre também o caminho "usar minha localização atual" (geolocation), que
  // salva a localização em body.html e dispara este mesmo evento.
  sincronizarCepCartKeep();
});
